import { useContext, useEffect, useRef, useState } from "react";
import {
  LimpiarSelectCM,
  LimpiarSelectGlobal,
  SelectUserCM,
  SelectUserGlobal,
} from "../../context/Actions/DropDownFamiliares/selectFamiliares";
import {
  estudioGrupo,
  estudiosMasSolicitadosPorPaciente,
  filtrarEstudioGrupoPorEdad,
} from "../../context/Actions/estudioGrupo/estudioGrupo";
import {
  laboGrupo,
  wsGetLaboCentros,
} from "../../context/Actions/laboGrupo/laboGrupo";
import { showModal, hideModal } from "../../context/Actions/modal/modal";
import { logoutConsultaMedTurnos } from "../../context/Actions/turnos/consultaMedTurnos";
import { logoutEstudiosTurnos } from "../../context/Actions/turnos/estudioTurnos";
import { finalizaTurnosDisponibles } from "../../context/Actions/turnos/turnosDisponibles";
import { PortalContext } from "../../context/Provider";
import { displayAyudaMobile } from "../../../global/utils/ayuda";
import { GlobalContext } from "../../../global/context/Provider";
import {
  resetPresentismo,
  wsGetPresentismoDetalle,
} from "_+_Portal/context/Actions/presentismo/presentismo";
import {
  BodyContainerMotion,
  BoxBuscadorLineaContainer,
  BoxSaludoBuscador,
  BoxSaludoPresentismo,
  BtnBox,
  BtnOpcContainer,
  MobileBuscador,
  MotionContainerScroll,
} from "./localStyle";
import { useHistory } from "react-router";
import { wsGetTextos } from "_+_Portal/context/Actions/textos/textos";
import BurguerMobile from "../../components/Genericos/BurguerMobile/BurguerMobile";
import HeaderbarHome from "../../components/Genericos/HeaderbarHome/HeaderbarHome";
import Loading from "../../components/Genericos/Loading/Loading";
import Modal from "../../components/Genericos/Modal/Modal";
import Sidebar from "../../components/Genericos/Sidebar/Sidebar";
import TituloSaludo from "../../components/Genericos/TituloSaludo/TituloSaludo";
import ToasterV2 from "../../../global/component/Genericos/Toaster/ToasterV2";
import MultitabMobile from "../../components/Turnos/MultitabMobile/MultitabMobile";
import routes from "_+_Portal/routes/listRoutes";
import ConsultaMedica from "../ConsultaMedica/ConsultaMedica";
import Estudios from "../Estudios/Estudios";
import Laboratorio from "../Laboratorio/Laboratorio";
import PresentismoBox from "_+_Portal/components/Turnos/PresentismoBox/PresentismoBox";
import PasosTurno from "_+_Portal/components/Turnos/PasosTurno/PasosTurno";
import LineaPasos from "_+_Portal/components/Turnos/LineaPasos/LineaPasos";
import "./BuscadorTurnos.css";
import { showToaster } from "global/context/action/toaster/toaster";

const BuscadorTurnos = () => {
  const {
    estudioGrupoDispatch,
    estudioGrupoState,
    modalState,
    laboGrupoState,
    laboGrupoDispatch,
    modalDispatch,
    selectDropDownDispatch,
    turnosDisponiblesDispatch,
    turnosDisponiblesState,
    estudioTurnosDispatch,
    consultaMedTurnosDispatch,
    textosState,
    presentismoState,
    listaFamiliaresState,
    presentismoDispatch,
    selectDropDownState,
    pacienteState,
    estudioTurnosState,
    consultaMedTurnosState,
    textosDispatch,
  } = useContext(PortalContext);
  const { authState, toasterState, toasterDispatch, configState } =
    useContext(GlobalContext);

  let config = localStorage.getItem("config");
  let bloqueoPresentismo = config ? JSON.parse(config).opcBloqueoPresentismo : false;

  const [showBurguerMobile, setShowBurguerMobile] = useState(false);
  const [pasosCompletados, setPasosCompletados] = useState([]);
  const [errorPermisos, setErrorPermisos] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingOrden, setLoadingOrden] = useState(false);

  const history = useHistory();

  const onShowBurguerHandle = () => {
    setShowBurguerMobile(true);
  };

  const onCloseBurguerMobile = (type) => {
    if (type === "open") setShowBurguerMobile(true);
    else setShowBurguerMobile(false);
  };

  //repetir en las paginas para tener los datos de los grupos
  useEffect(() => {
    // Solo ejecutar estudioGrupo una vez si no hay datos
    if (estudioGrupoState.estudioGrupo.data === null) {
      estudioGrupo(authState?.auth?.data?.paciente)(estudioGrupoDispatch);
    }
    //complemento textos siempre lo ultimo
    wsGetTextos()(textosDispatch);
  }, []); // Sin dependencias para ejecutar solo una vez

  useEffect(() => {
    if (!configState.config.data) return;
    // Cargar datos de laboratorio solo si está habilitado y no hay datos
    if (
      configState.config.data.opcLaboratorio &&
      laboGrupoState.laboGrupo.data === null
    ) {
      laboGrupo()(laboGrupoDispatch);
    }
    // Cargar centros de laboratorio solo si está habilitado y no hay centros
    if (
      configState.config.data.opcLaboratorio &&
      laboGrupoState.laboGrupo.centros === null
    ) {
      wsGetLaboCentros()(laboGrupoDispatch);
    }

    displayAyudaMobile("visible");
    // Limpiar estados si viene de consulta médica
    if (
      turnosDisponiblesState.turnosDisponibles.turnosData.volverOrigen ===
      "CONSULTA_MEDICA"
    ) {
      logoutConsultaMedTurnos()(consultaMedTurnosDispatch);
      logoutEstudiosTurnos()(estudioTurnosDispatch);
      finalizaTurnosDisponibles()(turnosDisponiblesDispatch);
    }
  }, [configState.config.data]);

  useEffect(() => {
    if (
      laboGrupoState.laboGrupo.centros !== null &&
      laboGrupoState.laboGrupo.centros !== undefined
    ) {
      localStorage.setItem(
        "laboCentros",
        JSON.stringify(laboGrupoState.laboGrupo.centros),
      );
    }
  }, [laboGrupoState.laboGrupo.centros]);

  const onChangeMultitabMobile = (e) => {
    // Aquí hay que hacer un dispatch
    // Para poder elegir el usuario
    const dataOriginal = estudioGrupoState.estudioGrupo.dataOriginal;

    if (e !== "") {
      if (
        e.id &&
        e.id !== authState?.auth?.data?.paciente?.codigo &&
        e.manejoTurnos
      ) {
        SelectUserCM({ id: e.id, paciente: e.paciente })(
          selectDropDownDispatch,
        );
        SelectUserGlobal({ id: e.id, paciente: e.paciente })(
          selectDropDownDispatch,
        );
        estudiosMasSolicitadosPorPaciente(e.id)(estudioGrupoDispatch);
        // Filtrar grupos de estudio por edad del familiar seleccionado
        filtrarEstudioGrupoPorEdad(
          dataOriginal,
          e.paciente,
        )(estudioGrupoDispatch);
        setErrorPermisos(false);
      } else if (e.id !== authState?.auth?.data?.paciente?.codigo) {
        showToaster(
          {
            texto: "No posees permisos para gestionar turnos de este familiar.",
            tipo: "warning",
          },
          "centroArriba",
        )(toasterDispatch);
        LimpiarSelectCM()(selectDropDownDispatch);
        LimpiarSelectGlobal()(selectDropDownDispatch);
        let buscarPaso = pasosCompletados.filter(
          (item) => item.id !== 2 && item.id !== 3,
        );
        setPasosCompletados(buscarPaso);
        setErrorPermisos(true);
      } else {
        // Volvió a seleccionar el paciente principal
        estudiosMasSolicitadosPorPaciente()(estudioGrupoDispatch);
        LimpiarSelectCM()(selectDropDownDispatch);
        LimpiarSelectGlobal()(selectDropDownDispatch);
        // Filtrar grupos de estudio por edad del paciente principal
        filtrarEstudioGrupoPorEdad(
          dataOriginal,
          authState?.auth?.data?.paciente,
        )(estudioGrupoDispatch);
        setErrorPermisos(false);
      }
    } else {
      LimpiarSelectCM()(selectDropDownDispatch);
      setErrorPermisos(false);
      // comentado como en estudios.
    }
  };

  // ------------------------ MODAL PUBLICITARIO ------------------------------------
  useEffect(() => {
    let publicidad = textosState?.textos?.data?.publicidades;
    const view = JSON.parse(localStorage.getItem("publicidad_portal"));
    if (publicidad && publicidad.length > 0 && !view) {
      showModal(
        "Turnos/Publicidad/Publicidad",
        {
          publicidad: publicidad,
        },
        [],
        "centro",
        true,
      )(modalDispatch);
    }
  }, [
    textosState?.textos?.data?.publicidades,
    estudioGrupoState.estudioGrupo.loading,
  ]);
  // ------------------------ MODAL PUBLICITARIO ------------------------------------

  const handlePasosCompletados = (id, data) => {
    // Encuentra la posición del objeto con id igual a id(parametro)
    const index = pasosCompletados.findIndex((objeto) => objeto.id === id);

    if (index !== -1) {
      // Si se encuentra un objeto con id igual a id(parametro), lo reemplazo
      const newData = [...pasosCompletados];
      newData[index] = { id: id, desc: data };
      setPasosCompletados(newData);
    } else {
      // Si no se encuentra un objeto con id igual a id(parametro), agrega el nuevo objeto al arreglo
      setPasosCompletados([...pasosCompletados, { id: id, desc: data }]);
    }
  };

  // Si elijo labo borro el ultimo paso y pongo el buscador en el 3er paso ya que
  // no tenemos estudios mas buscados en laboratorio
  useEffect(() => {
    if (
      pasosCompletados.length > 2 &&
      (pasosCompletados[0].desc === "Labo" ||
        pasosCompletados[0].desc === "Estudio")
    ) {
      let borrarUltimo = pasosCompletados.filter((item) => item.id !== 3);
      setPasosCompletados(borrarUltimo);
    }
  }, [pasosCompletados]);

  const dissmiss = () => {
    hideModal()(modalDispatch);
    resetPresentismo()(presentismoDispatch);
  };

  const modalInfoPresentismo = () => {
    showModal(
      "Genericos/Mensaje/Mensaje",
      {
        titulo: <span className="rb24b">Información</span>,
        textoNegrita: (
          <span
            className="rb18l explicacionPresentismo"
            dangerouslySetInnerHTML={{
              __html:
                textosState?.textos?.data?.msjPresentismoAyuda?.descripcion,
            }}
          ></span>
        ),
        dissmiss: dissmiss,
      },
      [
        {
          text: "Aceptar",
          clase: "btn-Mensaje b-latex30 c-latex30 rb16m",
          accion: dissmiss,
        },
      ],
      "centro",
      true,
    )(modalDispatch);
  };

  const modalTurnosPresentismo = () => {
    if (pasosCompletados?.length > 0) {
      if (selectDropDownState.selectDropDown.selectGlobal.pacienteElegido) {
        wsGetPresentismoDetalle(
          pasosCompletados[0].desc === "Consulta" ? true : false,
          selectDropDownState.selectDropDown.selectGlobal.pacienteElegido.id,
          showModalPresentismo,
        )(presentismoDispatch);
      } else {
        wsGetPresentismoDetalle(
          pasosCompletados[0].desc === "Consulta" ? true : false,
          false,
          showModalPresentismo,
        )(presentismoDispatch);
      }
    }
  };

  const showModalPresentismo = (isCorrect, data) => {
    if (isCorrect) {
      showModal(
        "Turnos/ModalPresentismo/ModalPresentismo",
        {
          dissmiss: dissmiss,
          danger: true,
        },
        [],
        "centro",
        true,
      )(modalDispatch);
    } else {
      showToaster(
        {
          texto: "Ha ocurrido un error al consultar presentismo",
          tipo: "danger",
        },
        "centroArriba",
      )(toasterDispatch);
    }
  };

  useEffect(() => {
    if (pasosCompletados.length) {
      let cuerpo =
        document.documentElement.getElementsByClassName("containerScroll");
      if (cuerpo.length > 0) {
        const scrollToBottom = cuerpo[0].scrollHeight - cuerpo[0].clientHeight;
        if (pasosCompletados.length === 2) {
          cuerpo[0].scrollTo({ top: scrollToBottom, behavior: "smooth" });
        } else if (pasosCompletados.length === 3) {
          cuerpo[0].scrollTo({ top: scrollToBottom, behavior: "smooth" });
        } else if (pasosCompletados.length === 1 && window.innerWidth <= 1790) {
          cuerpo[0].scrollTo({ top: 250, behavior: "smooth" });
        }
      }
    }
  }, [pasosCompletados]);

  const div1Ref = useRef(null);
  const div2Ref = useRef(null);
  const div3Ref = useRef(null);
  const div4Ref = useRef(null);

  const [distance, setDistance] = useState(null);
  const [distance2, setDistance2] = useState(null);
  const [distance3, setDistance3] = useState(null);
  const [transicionTerminada, setTransicionTerminada] = useState(false);

  useEffect(() => {
    const div1 = div1Ref.current;
    const div2 = div2Ref.current;
    const div3 = div3Ref.current;
    const div4 = div4Ref.current;

    const handleTransitionEnd = () => {
      // setTransicionTerminada(true);
      if (pasosCompletados.length === 1) {
        // Calcular distancia entre centros después de que la transición haya terminado
        const centroDiv1 = {
          x: div1.offsetWidth / 2 + div1.getBoundingClientRect().left,
          y: div1.offsetHeight / 2 + div1.getBoundingClientRect().top,
        };

        const centroDiv2 = {
          x: div2.offsetWidth / 2 + div2.getBoundingClientRect().left,
          y: div2.offsetHeight / 2 + div2.getBoundingClientRect().top,
        };

        const distanciaY = Math.abs(centroDiv2.y - centroDiv1.y);
        setDistance(distanciaY);
      } else if (pasosCompletados.length === 2) {
        const centroDiv2 = {
          x: div2.offsetWidth / 2 + div2.getBoundingClientRect().left,
          y: div2.offsetHeight / 2 + div2.getBoundingClientRect().top,
        };

        const centroDiv3 = {
          x: div3.offsetWidth / 2 + div3.getBoundingClientRect().left,
          y: div3.offsetHeight / 2 + div3.getBoundingClientRect().top,
        };

        const distanciaY2 = Math.abs(centroDiv3.y - centroDiv2.y);
        setDistance2(distanciaY2);
      } else if (pasosCompletados.length === 3) {
        const centroDiv3 = {
          x: div3.offsetWidth / 2 + div3.getBoundingClientRect().left,
          y: div3.offsetHeight / 2 + div3.getBoundingClientRect().top,
        };

        const centroDiv4 = {
          x: div4.offsetWidth / 2 + div4.getBoundingClientRect().left,
          y: div4.offsetHeight / 2 + div4.getBoundingClientRect().top,
        };

        const distanciaY3 = Math.abs(centroDiv4.y - centroDiv3.y);
        setDistance3(distanciaY3);
      }
    };

    // setTransicionTerminada(false);

    if (pasosCompletados.length === 1) {
      div2.addEventListener("transitionend", handleTransitionEnd);
    }
    if (pasosCompletados.length === 2) {
      div3.addEventListener("transitionend", handleTransitionEnd);
    }
    if (pasosCompletados.length === 3) {
      div4.addEventListener("transitionend", handleTransitionEnd);
    }

    // Limpia los event listeners cuando el componente se desmonta o cambia de estado
    return () => {
      if (pasosCompletados.length === 1) {
        div2.removeEventListener("transitionend", handleTransitionEnd);
      }
      if (pasosCompletados.length === 2) {
        div3.removeEventListener("transitionend", handleTransitionEnd);
      }
      if (pasosCompletados.length === 3) {
        div4.removeEventListener("transitionend", handleTransitionEnd);
      }

      // Limpia los event listeners para los otros elementos.
    };
  }, [pasosCompletados]);

  const navegarA = (id, ruta) => {
    const index = routes.findIndex((objeto) => objeto.id === id);
    if (index === -1) {
      routes.push(
        {
          id: 9,
          path: "/consultamedica",
          component: ConsultaMedica,
          title: "Buscador Consulta Médica",
          needsAuth: true,
        },
        {
          id: 10,
          path: "/estudios",
          component: Estudios,
          title: "Buscador Estudio",
          needsAuth: true,
        },
        {
          id: 11,
          path: "/laboratorio",
          component: Laboratorio,
          title: "Buscador Laboratorio",
          needsAuth: true,
        },
      );
    }
    history.push(ruta);
  };

  return (
    <>
      {modalState.modal.show && <Modal />}
      {toasterState.toaster.show && <ToasterV2 />}

      <BurguerMobile
        onCloseBurguerMobile={onCloseBurguerMobile}
        showBurguerMobile={showBurguerMobile}
      />
      <HeaderbarHome onShowBurguerHandle={onShowBurguerHandle} />
      <Loading
        dataLoading={
          estudioTurnosState.estudioTurnos.loading ||
          consultaMedTurnosState.consultaMedTurnos.loading ||
          estudioGrupoState.estudioGrupo.loading ||
          presentismoState.presentismo.loading ||
          listaFamiliaresState.listaFamiliares.loading ||
          pacienteState.paciente.loading ||
          estudioGrupoState.estudiosMasBuscado.loading ||
          estudioGrupoState.estudioGrupo.data === null ||
          loadingOrden ||
          loading
        }
        color="c-white"
        descripcion={
          (estudioGrupoState.estudioGrupo.loading &&
            "Cargando buscador de turnos...") ||
          (presentismoState.presentismo.loading && "Cargando turnos...") ||
          (pacienteState.paciente.loading && "Cargando datos paciente...") ||
          (listaFamiliaresState.listaFamiliares.loading &&
            "Cargando familiares...") ||
          ((estudioTurnosState.estudioTurnos.loading ||
            consultaMedTurnosState.consultaMedTurnos.loading ||
            loading) &&
            "Cargando turnos disponibles...") ||
          (estudioGrupoState.estudiosMasBuscado.loading &&
            "Cargando estudios mas buscados...") ||
          (estudioGrupoState.estudioGrupo.data === null &&
            "Cargando buscador de turnos...") ||
          (loadingOrden && "Subiendo orden...")
        }
      />
      <MultitabMobile
        posicionMultitab={5}
        onChangeMultitabMobile={onChangeMultitabMobile}
        type={"CONSULTA_MEDICA"}
      />

      {estudioGrupoState.estudioGrupo.data &&
        !estudioGrupoState.estudioGrupo.loading && (
          <BodyContainerMotion
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{
              duration: 1.5,
              ease: "easeInOut",
              opacity: [0, 0.3, 0.7, 1],
              times: [0, 0.3, 0.7, 1],
            }}
          >
            <Sidebar />
            <MotionContainerScroll
              initial={{ opacity: 0, x: +100 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: 100 }}
              transition={{ type: "keyframes" }}
              className={"containerScroll"}
            >
              <LineaPasos
                pasos={pasosCompletados}
                distance={distance}
                distance2={distance2}
                distance3={distance3}
                transicionTerminada={transicionTerminada}
              />
              <BoxSaludoBuscador>
                <BoxSaludoPresentismo>
                  <TituloSaludo />
                  <div className="ptur-buscadorTurnos-desktop-dropdown">
                    {bloqueoPresentismo &&
                      pasosCompletados.length > 1 &&
                      pasosCompletados[0].desc !== "Labo" && (
                        <PresentismoBox
                          consultas={
                            pasosCompletados[0].desc === "Consulta"
                              ? true
                              : false
                          }
                          pasos={pasosCompletados}
                          modalInfoPresentismo={modalInfoPresentismo}
                          modalTurnosPresentismo={modalTurnosPresentismo}
                        />
                      )}
                  </div>
                </BoxSaludoPresentismo>
                <BoxBuscadorLineaContainer $pasos={pasosCompletados.length}>
                  <PasosTurno
                    pasos={pasosCompletados}
                    setPasosCompletados={setPasosCompletados}
                    handlePasosCompletados={handlePasosCompletados}
                    onChangeMultitabMobile={onChangeMultitabMobile}
                    errorPermisos={errorPermisos}
                    div1Ref={div1Ref}
                    div2Ref={div2Ref}
                    div3Ref={div3Ref}
                    div4Ref={div4Ref}
                    setLoadingOrden={setLoadingOrden}
                    loading={loading}
                    setLoading={setLoading}
                  />
                </BoxBuscadorLineaContainer>
              </BoxSaludoBuscador>
            </MotionContainerScroll>
            <MobileBuscador>
              <p className="c-white rb18m">
                ¿Para que estás buscando un turno?
              </p>

              <p className="c-white rb16l">
                Seleccioná la opción según lo que estas buscando
              </p>
              <BtnBox>
                <BtnOpcContainer
                  className={"c-white rb18l"}
                  onClick={() => navegarA(9, "/consultamedica")}
                >
                  Consulta médica
                </BtnOpcContainer>
                <BtnOpcContainer
                  className={"c-white rb18l"}
                  onClick={() => navegarA(10, "/estudios")}
                >
                  Estudio
                </BtnOpcContainer>
                <BtnOpcContainer
                  className={"c-white rb18l"}
                  onClick={() => navegarA(11, "/laboratorio")}
                >
                  Laboratorio
                </BtnOpcContainer>
              </BtnBox>
            </MobileBuscador>
          </BodyContainerMotion>
        )}
    </>
  );
};

export default BuscadorTurnos;
